import { atom } from 'recoil'
import { IMDMUnit } from '@/pages/MDM/mdm.types.ts'

interface IMDMUnitsAtomState {
  items: IMDMUnit[]
}

const unitsAtom = atom<IMDMUnitsAtomState>({
  key: '/mdm/units',
  default: {
    items: [],
  },
})
export default unitsAtom
